import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#181E2A", // some kind really dark, bluey black... but mostly black
        secondary: "#ED1B24", // reddish, same colour as the eSafe logo
        accent: "#00A68E", // tealy green
        // these ones below are not necessarily the eSafe theme colours, they are just traffic light stuff - consider before using
        error: "#DB2828", // red
        info: "#31CCEC", // darkish sky blue
        success: "#08B077", // dark green
        warning: "#FBC02D" // orange
      }
    },
    options: {
      customProperties: true
    }
  }
});
